import { Dispatch, SetStateAction, useRef } from "react";
import { Whisper, Popover, WhisperInstance } from "rsuite";
import IconButton from "../../../elements/IconButton";

export const ReactionEmojis: Record<string, any> = {
  Like: { emoji: "👍" },
  Heart: { icon: "mdi mdi-heart text-danger" },
  Laugh: { emoji: "😂" },
  Applause: { emoji: "👏" },
  Celebration: { emoji: "🥳" },
  Surprised: { emoji: "😯" },
};

interface Props {
  handleReaction: (reaction: string) => void;
  setMenuOpen: Dispatch<SetStateAction<boolean>>;
}

export function CommentReactions({ setMenuOpen, handleReaction }: Props) {
  const whisperRef = useRef<WhisperInstance>(null);

  return (
    <Whisper
      placement="bottomEnd"
      trigger={"click"}
      ref={whisperRef}
      speaker={
        <Popover className="sidebar-popover mt-2" style={{ minWidth: "unset" }}>
          <div className="d-flex px-1">
            {Object.keys(ReactionEmojis).map((name) => {
              const reactionData = ReactionEmojis[name];
              const onClick = () => {
                handleReaction(name);
                whisperRef.current?.close();
              };
              const css =
                "text-lg cursor-pointer bg-superlight--hover px-2 rounded-sm";

              if (reactionData.emoji) {
                return (
                  <div key={name} className={css} onClick={onClick}>
                    {reactionData.emoji}
                  </div>
                );
              } else if (reactionData.icon) {
                return (
                  <i
                    key={name}
                    className={`${css} ${reactionData.icon}`}
                    onClick={onClick}
                  />
                );
              } else {
                return null;
              }
            })}
          </div>
        </Popover>
      }
      onOpen={() => setMenuOpen(true)}
      onClose={() => setMenuOpen(false)}
    >
      <div>
        <IconButton
          icon="emoticon-plus-outline"
          className="mr-0"
          onClick={undefined}
        />
      </div>
    </Whisper>
  );
}
